import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { FamilyInviationService } from 'src/app/Service/familyinviation.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-accept-fc-invite-from-user',
    templateUrl: './accept-fc-invite-from-user.component.html',
    styleUrls: ['./accept-fc-invite-from-user.component.css'],
    standalone: false
})
export class AcceptFcInviteFromUserComponent implements OnInit{

  isCollapsed = true;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public familyInviationService: FamilyInviationService,
  ) {
    //
    this.activatedRoute.params.subscribe((params) => {
      if (params)
        this.familyInviationService.getFCInvitationDetails(params['id']).subscribe();
      else this.router.navigateByUrl('');
    });
  }

  ngOnInit(): void {
    if (this.userService.isLoggedin) {
      this.router.navigateByUrl('/user');
    } else {
      this.loader.HideLoading();
    }
  }

}
